import React from "react";
import { useSelector } from "react-redux";

import { Typography, Drawer } from "@material-ui/core";
import PassengerCard from "../components/passengerCard";
import TripType from "../components/tripType";
import JourneyClass from "../components/journeyClass";
import OriginDestination from "../components/OriginDestInput/OriginDestInput";
import JourneyDate from "../components/JourneyDate/JourneyDate";
import IconSearch from "@material-ui/icons/Search";
import "../index.css";
import FlyDuration from "../components/filters/FlyDuration";
import SortBy from "../components/filters/SortBy";
import PriceRange from "../components/filters/PriceRange.js";
import DepartureTimeRange from "../components/filters/TimeRange";
import ArrivalTimeRange from "../components/filters/TimeRange";
import Baggages from "../components/filters/Baggages";
import MaxStops from "../components/filters/MaxStops";
import moment from "moment";
import "./flightSearchMob.css";
import classes from "./FlightSearch.module.css";

const PRICE_RANGES = {
  USD: [0, 5000],
  AUD: [0, 10000],
  INR: [0, 100000],
};
const JOURNEY_TYPES = ["One Way", "Return"];

const DateStringToDate = (d) => new Date(d);

function FlightSearch(props) {
  const {
    selectedDepartureDate,
    setSelectedDepartureDate,
    journeyType,
    setJourneyType,
    selectedArrivalDate,
    setSelectedArrivalDate,
    departureAirport,
    setDepartureAirport,
    departureAirportName,
    setDepartureAirportName,
    arrivalAirport,
    setArrivalAirport,
    arrivalAirportName,
    setArrivalAirportName,
    adults,
    setAdults,
    kids,
    setKids,
    infants,
    setInfants,
    flightClass,
    setFlightClass,
  } = props;
  const currency = useSelector((state) => state.flight.currency);

  const page = 1;
  const searchQuery = "";

  const handleJourneyTypeChange = (v) => {
    if (v == "One Way") {
      setSelectedArrivalDate(null);
    }
    setJourneyType(v);
  };

  const handlePassengerUpdate = (data) => {
    if (data) {
      setAdults(data.adults);
      setKids(data.childrens);
      setInfants(data.infants);
    }
  };

  const handleSearch = () => {
    props.onSearchFlights();
  };

  return (
    <div className={`${classes.container} ${classes.cardSearchBox}`}>
      <div>
        <div
          className={`${classes["search-filters"]}`}
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-start", marginBottom: "1rem", paddingLeft: "2rem" }}
        >
          <div className="filter-box">
            <TripType
              value={journeyType}
              onChange={(d) => handleJourneyTypeChange(d)}
            />
          </div>
          <div className="filter-box">
            <JourneyClass
              value={flightClass}
              onChange={(d) => setFlightClass(d)}
            />
          </div>
          <div className="filter-box">
            <PassengerCard
              adults={adults}
              childrens={kids}
              infants={infants}
              onChange={handlePassengerUpdate}
            />
          </div>
        </div>
        <div className={`${classes.row} ${classes["search-area"]}`} style={{ justifyContent: "flex-start", paddingLeft: "2rem" }}>
          <div className={classes["search-box"]} style={{ flex: 1, maxWidth: 800 }}>
            <div className={classes["search-col"]}>
              <OriginDestination
                origin={{
                  code: departureAirport,
                  name: departureAirportName,
                }}
                onOriginChange={(d) => {
                  setDepartureAirport(d?.code);
                  setDepartureAirportName(d?.name);
                }}
                destination={{
                  code: arrivalAirport,
                  name: arrivalAirportName,
                }}
                onDestinationChange={(d) => {
                  setArrivalAirport(d?.code);
                  setArrivalAirportName(d?.name);
                }}
              />
            </div>
            <div className={classes["search-col"]}>
              <JourneyDate
                query={searchQuery}
                journeyType={journeyType}
                value={{
                  start:
                    selectedDepartureDate &&
                    moment(selectedDepartureDate).toDate(),
                  end:
                    selectedArrivalDate && moment(selectedArrivalDate).toDate(),
                }}
                onStartChange={(d) => {
                  setSelectedDepartureDate(DateStringToDate(d));
                }}
                onEndChange={(d) => {
                  setSelectedArrivalDate(DateStringToDate(d));
                }}
              />
            </div>
          </div>
          <button
            onClick={handleSearch}
            disabled={
              !journeyType ||
              !departureAirport ||
              !arrivalAirport ||
              !selectedDepartureDate ||
              !(
                (journeyType === JOURNEY_TYPES[1] && selectedArrivalDate) ||
                journeyType === JOURNEY_TYPES[0]
              ) ||
              !adults
            }
            className={classes["search-button"]}
            style={{ marginLeft: "1.5rem", height: "56px",width: "20%", alignSelf: "center" }}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(FlightSearch);
